module.exports = __webpack_public_path__ + "media/images/ico-tv@2x-286dfc9c6e48f3690a6659943d9716dc.png";